import { render, staticRenderFns } from "./VirtualTours.vue?vue&type=template&id=6f649ee4&"
import script from "./VirtualTours.vue?vue&type=script&lang=js&"
export * from "./VirtualTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports